/**
 * Onboarding API helpers. Thin wrapper over /v1/onboarding routes.
 *
 * The shared `request<T>` helper auto-unwraps `{ data: T }` envelopes,
 * so callers see the inner shape directly.
 */
import type { OnboardingState } from '@builder/shared';
import { request } from './client';

export const onboardingApi = {
  getState: () => request<OnboardingState>('/v1/onboarding'),
  markStep: (stepId: string) =>
    request<OnboardingState>('/v1/onboarding/step', {
      method: 'POST',
      body: JSON.stringify({ stepId }),
    }),
  dismiss: () =>
    request<{ ok: boolean }>('/v1/onboarding/dismiss', {
      method: 'POST',
      body: '{}',
    }),
  reset: (userId: string) =>
    request<{ ok: boolean }>(`/v1/onboarding/${userId}`, { method: 'DELETE' }),
};
